import { dataLayersQuerier } from "../../queriers/region";
import { RegionSlice } from "../slices";

export const regionSelectorCreator = (state: RegionSlice) => ({
  dataLayers: dataLayersQuerier(state.dataLayers)
});
